import { Utils, useBreakpointValue } from '@genial/utils';
import { RouteProp, useRoute } from '@react-navigation/native';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { CustomerDetailStackParamList } from '../../../../routes/types';
import { useCustomerAssetsDetailsActions } from '../../../../store/customerAssetDetail/actions';
import {
  updateCustomerAssetDetailsFilterSelected,
  updateCustomerAssetDetailsFilters,
  updateCustomerAssetDetailsFiltersLoading,
} from '../../../../store/customerAssetDetail/selector';
import { AssetsFilterProps } from '../../../../store/customerAssetDetail/types';
import { useCustomerDetailsActions } from '../../../../store/customerDetail/actions';
import {
  customersAssetsDateSelected,
  isExportingPdfForCustomersAssets,
} from '../../../../store/customerDetail/atom';
import { IInvestedAssetsNormalized } from '../../../../store/customerDetail/types';

import { FiltersDesktop } from './Desktop';
import { FiltersMobile } from './Mobile';

export namespace FiltersTypes {
  export interface BaseProps {
    isInline?: boolean;
    product: IInvestedAssetsNormalized;
  }

  export interface Props extends BaseProps {
    isToday: boolean;
    isExportingPdf: boolean;
    selectedDate: Date | undefined;
    onDownloadPdf: () => void;
    onDateSelected: (date?: Date | undefined) => void;
    assetsFilters: AssetsFilterProps[];
    assetsFiltersLoading: boolean;
    assetsFilterSelected: number;
    handleUpdateCustomerAssetsDetailsFiltersSelected: (selectedIndex: number) => void;
  }
}

export const Filters: React.FC<FiltersTypes.BaseProps> = (props) => {
  const route = useRoute<RouteProp<CustomerDetailStackParamList, 'CustomerDetail'>>();
  const isExportingPdf = useRecoilValue(isExportingPdfForCustomersAssets);
  const selectedDate = useRecoilValue(customersAssetsDateSelected);
  const assetsFilters = useRecoilValue(
    updateCustomerAssetDetailsFilters({ productType: props.product.marketTypeNormalized })
  );
  const assetsFiltersLoading = useRecoilValue(
    updateCustomerAssetDetailsFiltersLoading({ productType: props.product.marketTypeNormalized })
  );
  const assetsFilterSelected = useRecoilValue(
    updateCustomerAssetDetailsFilterSelected({ productType: props.product.marketTypeNormalized })
  );

  const { downloadCustomerAssetsDetailsPdf, setCustomersAssetsDateSelected } =
    useCustomerDetailsActions();

  const { handleUpdateCustomerAssetsDetailsFiltersSelected } = useCustomerAssetsDetailsActions(
    props.product.marketTypeNormalized
  );

  const isToday = !!selectedDate && Utils.Date.IsToday(selectedDate);

  const handleDownloadPdf = () => {
    downloadCustomerAssetsDetailsPdf({
      consolidatedDate: selectedDate || new Date(),
      accountId: route.params.accountId,
    });
  };

  const otherProps = {
    ...props,
    isToday,
    selectedDate,
    isExportingPdf,
    onDownloadPdf: handleDownloadPdf,
    onDateSelected: setCustomersAssetsDateSelected,
    assetsFilters,
    assetsFiltersLoading,
    assetsFilterSelected,
    handleUpdateCustomerAssetsDetailsFiltersSelected,
  };

  const content = useBreakpointValue({
    base: <FiltersMobile {...otherProps} />,
    sm: <FiltersDesktop {...otherProps} />,
    lg: <FiltersDesktop {...otherProps} />,
  });

  if (!props.product) {
    return <></>;
  }

  return content;
};
